// src/components/MetaPixelInit.tsx
import { useEffect } from "react";
import { persistFbcFromUrl } from "@/lib/meta-cookies";
import { captureUtmParams } from "@/lib/utm";
import { getCookieConsent } from "@/components/CookieBanner";

const META_PIXEL_ID = import.meta.env.VITE_META_PIXEL_ID as string | undefined;

const MetaPixelInit = () => {
  useEffect(() => {
    persistFbcFromUrl();
    captureUtmParams();

    if (!META_PIXEL_ID || !window.fbq) return;

    const consent = getCookieConsent();
    // Brazil: opt-out model. Grant by default so the pixel fires even before the
    // banner is touched. Only revoke if the user explicitly chose "Só essenciais".
    window.fbq("consent", consent === "essential" ? "revoke" : "grant");
    window.fbq("init", META_PIXEL_ID);
    // PageView is fired by individual pages via useMetaPixel().trackPageView()
    // which sends both browser Pixel + server-side CAPI with a shared eventId.
  }, []);

  return null;
};

export default MetaPixelInit;
